<div class="nav-tabs-navigation" style="border-radius: 25%;">
    <div class="nav-tabs-wrapper">
        <ngb-tabset class="text-center">
            <ngb-tab title="Precipitazioni diffuse">
                <ng-template ngbTabContent>
                    <div class="col-12" style="padding: 1.25rem;">

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4 col-sm-12 bg-green box-legenda">VERDE</div>
                            <div class="col-md-8 col-sm-12 info-box">
                                {{ precipitazioniVerdeBreve }}
                            </div>
                        </div>

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4 col-sm-12 bg-orange box-legenda">GIALLA</div>
                            <div class="col-md-8 col-sm-12 info-box">
                                {{ precipitazioniGiallaBreve }}
                            </div>
                        </div>

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4 col-sm-12 bg-red-light box-legenda">ARANCIONE</div>
                            <div class="col-md-8 col-sm-12 info-box">
                                {{ precipitazioniArancioneBreve }}
                            </div>
                        </div>

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4 col-sm-12 bg-red box-legenda">ROSSA</div>
                            <div class="col-md-8  col-sm-12 info-box">
                                {{ precipitazioniRossaBreve }}

                            </div>
                        </div>

                    </div>
                </ng-template>
            </ngb-tab>
            <ngb-tab title="Temporali">
                <ng-template ngbTabContent>
                    <div class="col-12" style="padding: 1.25rem;">

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4  col-sm-12 bg-green box-legenda">VERDE</div>
                            <div class="col-md-8 col-sm-12 info-box">
                                {{ temporaliVerdeBreve }}
                            </div>
                        </div>

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4  col-sm-12 bg-orange box-legenda">GIALLA</div>
                            <div class="col-md-8 col-sm-12 info-box ">
                                {{ temporaliGiallaBreve }}
                            </div>
                        </div>

                        <div class="row rowLivAllertaLeg">
                            <div class="col-md-4 col-sm-12 bg-red-light box-legenda">ARANCIONE</div>
                            <div class="col-md-8 col-sm-12 info-box ">
                                {{ temporaliArancioneBreve }}
                            </div>
                        </div>

                        <div class="row rowLivAllertaLeg">
                            <div class="col-12 info-box">
                                <span class="py-2" style="font-size: 15px; font-style: italic;opacity: 0.9;">{{ temporaliRossaBreve }}</span>
                            </div>
                        </div>

                    </div>
                </ng-template>
            </ngb-tab>
            <!-- <ngb-tab title="Vento">
            <ng-template ngbTabContent>
                <div class="col-12" style="padding: 1.25rem;">

                    <div >
                        <div class="col-md-4 col-sm-12 bg-green box-legenda">VERDE</div>
                        <div class="col-8">
                            Assenza o bassa probabilità a livello locale di fenomeni significativi prevedibili. Assenza o bassa probabilità a livello
                            locale di fenomeni significativi prevedibili. Assenza o bassa probabilità a livello locale di
                            fenomeni significativi prevedibili.
                        </div>
                    </div>

                    <div >
                        <div class="col-md-4 col-sm-12 bg-orange box-legenda">GIALLA</div>
                        <div class="col-8">

                            Occasionale pericolo: fenomeni ed effetti locali. Occasionale pericolo: fenomeni ed effetti locali.
                        </div>
                    </div>

                    <div >
                        <div class="col-md-4 col-sm-12 bg-red-light box-legenda">ARANCIONE</div>
                        <div class="col-8">
                            Pericolo: fenomeni ed effetti diffusi. Pericolo: fenomeni ed effetti diffusi. Pericolo: fenomeni ed effetti diffusi.
                        </div>
                    </div>

                    <div >
                        <div class="col-md-4 col-sm-12 bg-red box-legenda">ROSSA</div>
                        <div class="col-8">
                            Grave pericolo: fenomeni ed effetti ingenti ed estesi. Grave pericolo: fenomeni ed effetti ingenti ed estesi.
                        </div>
                    </div>

                </div>
            </ng-template>
        </ngb-tab> -->
        </ngb-tabset>
    </div>
</div>